var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-info"},[_c('div',{staticClass:"dot",style:({ background: _vm.validateColors() })})])}
var staticRenderFns = []

export { render, staticRenderFns }